import { SortByListType, TimeframesType } from './types';

export const timeframes: TimeframesType[] = [
  { friendlyValue: 'Anytime', value: 0 },
  { friendlyValue: 'Last day', value: 1 },
  { friendlyValue: 'Last 7 days', value: 7 },
  { friendlyValue: 'Last 30 days', value: 30 },
  { friendlyValue: 'Last 90 days', value: 90 },
  { friendlyValue: 'Last year', value: 365 },
];

const defaultSortByList: SortByListType[] = [
  { friendlyValue: 'Comments', value: 'comment_count' },
  { friendlyValue: 'Likes', value: 'like_count' },
  { friendlyValue: 'Most Recent', value: 'published_at' },
];

const instagramSortByList: SortByListType[] = [
  { friendlyValue: 'Comments', value: 'comment_count' },
  { friendlyValue: 'Engagement', value: 'engagement_count' },
  {
    friendlyValue: 'Followers Engagement Rate',
    value: 'post_followers_eng_rate',
  },
  { friendlyValue: 'Views', value: 'views' },
  { friendlyValue: 'Likes', value: 'like_count' },
  { friendlyValue: 'Most Recent', value: 'published_at' },
  { friendlyValue: 'Reach', value: 'reach_count' },
  { friendlyValue: 'Reach Engagement Rate', value: 'post_reach_eng_rate' },
  { friendlyValue: 'Saves', value: 'saved_count' },
];

const tiktokSortByList: SortByListType[] = [
  { friendlyValue: 'Comments', value: 'comment_count' },
  { friendlyValue: 'Engagement', value: 'engagement_count' },
  { friendlyValue: 'Likes', value: 'like_count' },
  { friendlyValue: 'Most Recent', value: 'published_at' },
  { friendlyValue: 'Views', value: 'view_count' },
];

const youtubeSortByList: SortByListType[] = [
  { friendlyValue: 'Comments', value: 'comment_count' },
  { friendlyValue: 'Likes', value: 'like_count' },
  { friendlyValue: 'Most Recent', value: 'published_at' },
  { friendlyValue: 'Shares', value: 'share_count' },
  { friendlyValue: 'Views', value: 'view_count' },
];

export const sortByList = {
  default: defaultSortByList,
  instagram: instagramSortByList,
  tiktok: tiktokSortByList,
  youtube: youtubeSortByList,
};
